import { Input } from "antd";
import classnames from "classnames";
import PropTypes from "prop-types";

import Label from "shared/components/Label";

const Simple = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  required,
  ...rest
}) => {
  return (
    <div
      className={classnames("input__wrapper number--input", {
        __error: touched && errors,
      })}
    >
      <Label label={label} icon={icon} required={required} />
      <div className={`input__wrapper--field`}>
        <Input
          type="number"
          className={classnames({
            "input--borderd--red": touched && errors,
            "disable--input": rest.disabled,
          })}
          placeholder={placeholder}
          {...rest}
        />
        {touched && errors && <p className={"input--errors"}>{errors}</p>}
      </div>
    </div>
  );
};

Simple.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Simple.defaultProps = {
  label: "",
  placeholder: "",
};

export default Simple;
